<template>
  <a-card :bordered="false">
    <search-page-view
      ref="table"
      rowKey="proId"
      :col="5"
      :itemNames="['search_proId','search_proName','create_button',]"
      :columns="getColumns()"
      :enableSearch="false"
      :queryParams="queryParams"
      :requestPromise="loadPromise"
    >
      <a-form-item slot="search_proId" style="margin-right: 10px">
        <a-input v-model="queryParams.productId" placeholder="请输入商品ID"></a-input>
      </a-form-item>
      <a-form-item slot="search_proName">
        <a-input v-model="queryParams.productName" placeholder="请输入商品名称"></a-input>
      </a-form-item>
      <a-form-item slot="create_button">
        <a-button style="margin-left:15px" type="primary" @click="$refs.table.refresh(true)">查 询</a-button>
      </a-form-item>
      <template slot="proCatalogStr">酒店</template>
    </search-page-view>
  </a-card>
</template>

<script>
import ZwyHotelMaiMixins from '@/views/service/serviceProvider/zwyHotel/mixins/ZwyHotelMaiMixins'

export default {
  name: 'ZwyHotelConnection',
  mixins: [ZwyHotelMaiMixins],
  data() {
    return {
      queryParams: {
        productId: '',
        productName: ''
      },
      loadPromise: params => this.getListPromise(params)
    }
  },
  mounted() {
    this.$store.commit('SET_MENU_HEAD_CONFIG', [
      { name: 'ZwyHotelConnection', title: '同步产品' },
      { name: 'ZwyHotelDirectOrder', title: '订单直连' },
      { name: 'ZwyHotelAssociatedAccount', title: '关联账号' }
    ])
  },
  methods: {
    // 获取表格数据接口
    getListPromise(params) {
      this.getLogUtils().logWithTag('==getListPromise==', params)
      return this.getHttpServices().getProService().post('v2/zwy/product/all', params)
    },
    getColumns() {
      return [
        {
          title: '自我游ID',
          dataIndex: 'proProductUrl'
        },
        {
          title: '商品名称',
          dataIndex: 'proName',
          width: '40%'
        },
        {
          title: '类型',
          dataIndex: 'proCatalogStr',
          scopedSlots: { customRender: 'proCatalogStr' }
        },
        {
          title: '更新时间',
          dataIndex: 'proUpdateTime'
        },
        {
          title: '供应商名称',
          dataIndex: 'accountName'
        }
      ]
    }
  }
}
</script>
<style scoped></style>
